import { render, staticRenderFns } from "./RequestsModal.vue?vue&type=template&id=ed45da0c&scoped=true&"
import script from "./RequestsModal.vue?vue&type=script&lang=js&"
export * from "./RequestsModal.vue?vue&type=script&lang=js&"
import style0 from "./RequestsModal.vue?vue&type=style&index=0&id=ed45da0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed45da0c",
  null
  
)

export default component.exports